import React from "react";
import { Table } from "reactstrap";
import { computeStandings } from "./standings";

// Tabla de posiciones de una zona, acumulada hasta la fecha seleccionada.
// Si se pasa `onTeamClick`, el nombre del equipo se vuelve clickeable (recibe el
// teamId); sin ese prop la tabla se comporta y se ve exactamente igual que antes.
export default function StandingsTable({ zone, upToFechaId, teams, onTeamClick }) {
  const rows = computeStandings(zone, upToFechaId);
  const teamName = (id) => {
    const t = teams.find((x) => x.id === id);
    return t ? t.name : "—";
  };

  if (rows.length === 0) {
    return (
      <p className="text-muted text-center py-3 my-0" style={{ fontSize: "0.875rem" }}>
        No hay equipos en la zona.
      </p>
    );
  }

  return (
    <div className="table-responsive">
      <Table className="standings-table mb-0" size="sm">
        <thead>
          <tr>
            <th style={{ width: "1.5rem" }}>#</th>
            <th className="text-left">Equipo</th>
            <th title="Puntos">Pts</th>
            <th title="Partidos jugados">PJ</th>
            <th title="Ganados">PG</th>
            <th title="Empatados">PE</th>
            <th title="Perdidos">PP</th>
            <th title="Goles a favor">GF</th>
            <th title="Goles en contra">GC</th>
            <th title="Diferencia de goles">Dif</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, index) => (
            <tr key={r.teamId} className={r.tied ? "standings-tied" : ""}>
              <td className="text-muted">{index + 1}</td>
              <td className="text-left standings-team">
                {onTeamClick ? (
                  <span
                    className="standings-equipo-link"
                    role="button"
                    tabIndex={0}
                    onClick={() => onTeamClick(r.teamId)}
                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onTeamClick(r.teamId)}
                  >
                    {teamName(r.teamId)}
                  </span>
                ) : (
                  teamName(r.teamId)
                )}
              </td>
              <td className="font-weight-bold">{r.pts}</td>
              <td>{r.pj}</td>
              <td>{r.pg}</td>
              <td>{r.pe}</td>
              <td>{r.pp}</td>
              <td>{r.gf}</td>
              <td>{r.gc}</td>
              <td>{r.dif > 0 ? "+" + r.dif : r.dif}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
